// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"150":"4f9aa04f","545":"32783348","551":"a22a53b6","605":"dd6279ae","662":"c0af0fd1","766":"406a6693"}[chunkId] + ".chunk.js";
};